document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.sharpening-service');
  if (!container) return;

  const form = container.querySelector('.sharpening-service__form');
  const addButton = form.querySelector('.sharpening-service__button');
  const checkbox = form.querySelector('.sharpening-service__checkbox');
  const quantityInput = form.querySelector('.qty');
  const variantId = container.dataset.productId;

  const pickupModal = container.querySelector('.sharpening-service__pickup-modal');
  const pickupContinue = pickupModal.querySelector('.sharpening-service__pickup-continue');
  const pickupCancel = pickupModal.querySelector('.sharpening-service__pickup-cancel');
  const pickupDate = pickupModal.querySelector('.sharpening-service__date');
  const pickupTime = pickupModal.querySelector('.sharpening-service__time');

  const confirmModal = container.querySelector('.sharpening-service__confirm-modal');
  const confirmContinue = confirmModal.querySelector('.sharpening-service__confirm-continue');
  const confirmCancel = confirmModal.querySelector('.sharpening-service__confirm-cancel');

  let pickupValues = {};

  const showPickupModal = () => {
    if (!checkbox.checkValidity()) {
      checkbox.reportValidity(); // Muestra el mensaje del navegador
      return;
    }
    pickupModal.classList.remove('hidden');
  };

  const handlePickupContinue = async () => {
    if (!pickupDate.value || !pickupTime.value) {
      alert('Por favor completa la fecha y hora.');
      return;
    }

    pickupValues = {
      _pickupDate: pickupDate.value,
      _pickupTime: pickupTime.value
    };

    pickupModal.classList.add('hidden');

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (cart.items.length > 0) {
        confirmModal.classList.remove('hidden');
      } else {
        await addToCart();
      }
    } catch (err) {
      console.error('Error al comprobar el carrito:', err);
    }
  };

  const handlePickupCancel = () => {
    pickupModal.classList.add('hidden');
  };

  const handleConfirmCancel = () => {
    confirmModal.classList.add('hidden');
  };

  const handleConfirmContinue = async () => {
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      confirmModal.classList.add('hidden');
      await addToCart();
    } catch (err) {
      console.error('Error al vaciar el carrito:', err);
    }
  };

  const addToCart = async () => {
    const quantity = parseInt(quantityInput.value) || 1;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: pickupValues
        })
      });

      if (!res.ok) throw new Error('Falló el POST');

      await res.json();
      form.reset();

      pickupDate._flatpickr.clear(); 
      pickupTime.value = "";
      pickupValues = {};

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      document.querySelector('#cart-drawer-toggle').click();
    } catch (err) {
      console.error('Error al añadir al carrito:', err);
    }
  };

  const checkDates = async () => {
    const dateInput = document.querySelector('.sharpening-service__date');

    try {
      const res = await fetch('https://app.arcos.lineagrafica.es/api/public/sharpening/settings', {
        method: 'POST',
        body: JSON.stringify({
            "shop": "arcos-plus-store.myshopify.com"
        })
      });

      if (!res.ok) throw new Error('Falló el POST');

      const json = await res.json();
      const settings = json.data.settings;
      const disabledDates = json.data.daysOff.map(day => day.date.slice(0, 10)); 
      const timeLimit = parseInt(settings.timeLimit, 10);

      const dateToYMD = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      const todayStr = dateToYMD(now);
      const tomorrowStr = dateToYMD(tomorrow);
      const disableTomorrow = now.getHours() >= timeLimit;

      flatpickr(dateInput, {
        locale: shopLang,
        minDate: 'today',
        dateFormat: 'd/m/Y',
        disable: [
          function(date) {
            const day = date.getDay();
            const dateStr = dateToYMD(date);

            if (dateStr === todayStr) return true;
            if (disableTomorrow && dateStr === tomorrowStr) return true;
            if (!settings.pickupAllowedForSundays && day === 0) return true;
            if (!settings.pickupAllowedForSaturdays && day === 6) return true;
            return disabledDates.includes(dateStr);
          }
        ],
        onChange: function(selectedDates, dateStr, instance) {
          const wrapper = dateInput.closest('.flatpickr-wrapper');
          if (!wrapper) return;

          if (dateStr) {
            wrapper.classList.add('has-value');
          } else {
            wrapper.classList.remove('has-value');
          }
        }
      });
    } catch (err) {
      console.error('Error al consultar fechas:', err);
    }
  };

  // Listeners
  addButton.addEventListener('click', showPickupModal);
  pickupContinue.addEventListener('click', handlePickupContinue);
  pickupCancel.addEventListener('click', handlePickupCancel);
  confirmCancel.addEventListener('click', handleConfirmCancel);
  confirmContinue.addEventListener('click', handleConfirmContinue);
  form.addEventListener('submit', e => e.preventDefault());

  container.querySelectorAll('.modal__close-button').forEach(button => {
    button.addEventListener('click', () => {
      const modal = button.closest('.sharpening-service__pickup-modal, .sharpening-service__confirm-modal');
      if (modal) modal.classList.add('hidden');
    });
  });

  checkDates();
});
